import type {
  IsGstRegisteredVerifyType,
  LeaveStatus,
  SingleWFHLeaveApplyDataType,
  StcoToolsType,
  WorkFromHomeStatus,
} from "@/redux/stcoTools/stcoToolsType";

export const initialState: StcoToolsType = {
  fetching: false,
  message: null,
  error: null,
  success: null,
  statusCode: null,
  totalUserCountList: null,
  totalClientList: null,
  getidPasswordManagerList: [],
  getClientidPasswordManagerList: [],
  leaveAndWFHHistoryList: [],
  upcomingList: [],
  singleLeaveAndWFHApplyData: {} as SingleWFHLeaveApplyDataType,
  leaveStatus: {} as LeaveStatus,
  workFromHomeStatus: {} as WorkFromHomeStatus,
  leaveTotalCount: 0,
  balanceLeave: {} as LeaveStatus,
  approvedLeave: 0,
  gstRegisterMessage: null,
  gstRegisterSuccess: null,
  isGstRegisteredVerifyData: {} as IsGstRegisteredVerifyType,
  fileUploadFetching: false,
  fileUploadData: [],
  sasTokenForDownloadFile: "",
  sasTokenForDownloadFetching: false,
  fileUploadSuccess: null,
  fileUploadError: null,
  fileUploadMessage: null,
};
